
jQuery("#ciudad").change(function() {
if (jQuery("#ciudad option[value=selectionKey]").attr('selected', 'selected')) {
  console.log('Select cambio a: ', $("#ciudad").val());
  localStorage.setItem('ciudadVarianteFinal', $("#ciudad").val());
  localStorage.setItem('ciudadCiudadFinal', $( "#ciudad option:selected" ).text());
  clearcart();
}

});
jQuery(document).ready(function($) {
  if (!localStorage.getItem('ciudadVarianteFinal')) {
    $("#modal--ciudades").attr({
      "aria-hidden": 'false' // Abre el popup
    });
  } else {
    clickCity();
    $("#modal--ciudades").attr({"aria-hidden": 'true'});
    if (!localStorage.getItem('modal--ciudad')) {
      $("#modal--imagen").attr({
        "aria-hidden": 'false' // Abre el popup
      });
    } else {
      $("#modal--imagen").attr({
        "aria-hidden": 'true' // Cierra el popup
      });
    }
    
  } 
  $('.popover__link-item').click(function() {
    localStorage.setItem('ciudadVarianteFinal', $(this).val());
    localStorage.setItem('ciudadCiudadFinal', $(this).text());
    clearcart();
  });
  
});
function abrirCoberturas() {
  $("#modal--ciudades").attr({
    "aria-hidden": 'false' // Abre el popup
  });
}
function cerrarCoberturas() {
  $("#modal--ciudades").attr({
    "aria-hidden": 'true' // Cierra el popup
  });
  localStorage.setItem('ciudadVarianteFinal', 'Medellín');
  localStorage.setItem('ciudadCiudadFinal', 'Medellín');
  clearcart();
}
function clickCity() {
  var localizacion = localStorage.getItem('ciudadVarianteFinal');
  var ref_this = $("w3-button").find(localizacion);
  if (ref_this) {
    $('.w3-button.' + localizacion).trigger('click');
    $('.product-item.' + localizacion).css('display', 'block');
    $('.w3-container.' + localizacion).css('display', 'block');
    $('.block-swatch__item-text.' + localizacion).trigger('click');
    $('.tab-pane.fade.' + localizacion + ':first-child').addClass('active');
  }
}
function openCity(cityName) {
  var i;
  var x = document.querySelectorAll("city");
  //document.getElementById(cityName).style.display = "block";
  for (i = 0; i < x.length; i++) {
    x[i].style.display = "none";
  }
}
function clearcart() {
  $.ajax({
    type: "POST",
    url: '/cart/clear.js',
    data: '',
    dataType: 'json',
    success: function() {
      Shopify.clear();
    },
    error: function(XMLHttpRequest, textStatus) {}
  });
  setTimeout(function(){
    window.location.href = "/";
}, 300);
  
}
$('.header__action-item--locale .header__action-item-content .locale-selector__value').text(localStorage.getItem('ciudadCiudadFinal'));
$('#ciudadtooltip').text(localStorage.getItem('ciudadCiudadFinal'));
console.log('LocalStorage: ', localStorage.getItem('ciudadVarianteFinal'));
console.log('LocalStorage Ciudad: ', localStorage.getItem('ciudadCiudadFinal'));

/* DIRECCIONES */

$('.selector-address-province-default').on('change',(event) => {
    getCityList(event.target.value,'default');
    let citySelect =  $('.selector-address-city-default').find(":selected").val();
    $('.input-address-city-default--hidden').val(citySelect);
});
$('.selector-address-province-new').on('change',(event) => {
    getCityList(event.target.value,'new'); 
    let idAddress = event.target.id.replace('address-','').replace('[province]','');
    let citySelect =  $('#address-'+idAddress+'-city--select').find(":selected").val();
    $('.input-address-city-new--hidden').val(citySelect);
});
$('.selector-address-province').on('change',(event) => {
    let idAddress = event.target.id.replace('address-','').replace('[province]','');
    getCityListEdit(event.target.value, idAddress);
    let citySelect =  $('#address-'+idAddress+'-city--select').find(":selected").val();
    document.getElementById('address-'+idAddress+'[city]').value = citySelect;
    
});
 $('.selector-address-city-default').on('change',(event) => {
     $('.input-address-city-default--hidden').val(event.target.value);
 });
 $('.selector-address-city-new').on('change',(event) => {
    $('.input-address-city-new--hidden').val(event.target.value);
});
$('.selector-address-city-edit').on('change',(event) => {
    let idAddress = event.target.id.replace('address-','').replace('-city--select','');
    
    document.getElementById('address-'+idAddress+'[city]').value = event.target.value;
    
});
 function getCityList(name,type) {
    $('.selector-address-city-'+type).html('<option disabled="disabled" value="---" data-provinces="[]">---</option>');
    $(allCities).map((node, item) => { 
        if(name.toLowerCase() == item.Departamento.toLowerCase()){
            item.Municipio.map((city) => { 
                $('.selector-address-city-'+type).append('<option value="'+city+'" data-provinces="[]">'+city+'</option>')
            });
        }

    });
 }
 function getCityListEdit(name, id) {
    console.log(name, id);
    $('#address-'+id+'-city--select').html('<option disabled="disabled" value="---" data-provinces="[]">---</option>');
    $(allCities).map((node, item) => { 
        if(name.toLowerCase() == item.Departamento.toLowerCase()){
            item.Municipio.map((city) => { 
                $('#address-'+id+'-city--select').append('<option value="'+city+'" data-provinces="[]">'+city+'</option>')
            });
        }

    });
 }
 function getProvinceList() {
    $('.selector-address-province option').each(function() {
        allCities.map((item) => { 
        if ( $(this).val() == item.Departamento ) {
            $(this).addClass('city-enable');
        }
    });
    });
    $('.selector-address-province option').each(function() {
        if(!$(this).hasClass("city-enable")){
            $(this).remove();
        }
    });
    $('.selector-address-province-default option').each(function() {
        allCities.map((item) => { 
        if ( $(this).val() == item.Departamento ) {
            $(this).addClass('city-enable');
        }
    });
    });
    $('.selector-address-province-default option').each(function() {
        if(!$(this).hasClass("city-enable")){
            $(this).remove();
        }
    });
    $('.selector-address-province-new option').each(function() {
        allCities.map((item) => { 
        if ( $(this).val() == item.Departamento ) {
            $(this).addClass('city-enable');
        }
    });
    });
    $('.selector-address-province-new option').each(function() {
        if(!$(this).hasClass("city-enable")){
            $(this).remove();
        }
    });

    let provinceName = $('.selector-address-province-default').find(":selected").val();
    let idAddress = $('.selector-address-province-default').attr('id').replace('address-','').replace('[province]','');

    getCityList(provinceName,'default');

    getCityList(allCities[0].Departamento,'new');
    $('.input-address-city-new--hidden').val(allCities[0].Municipio[0]);

    let inputCity = $('.input-address-city-default--hidden').val();
    console.log(inputCity);
    $('.selector-address-city-default option:contains('+inputCity+')').attr('selected', 'selected');

    $('.selector-address-province').each(function() {
        let idAddress = $(this).attr('id').replace('address-','').replace('[province]','');
        inputCity = document.getElementById('address-'+idAddress+'[city]').getAttribute("value");
        let inputProvince = document.getElementById('address-'+idAddress+'[province]').getAttribute("data-default");
        if(inputProvince == "Bogotá, D.C."){
            inputProvince = "Bogotá";
            $(this).find('option:contains('+inputProvince+')').attr('selected', 'selected');
        }
        provinceName = $(this).find('option:selected').val();
        getCityListEdit(provinceName, idAddress);
        console.log(inputCity, idAddress);
        $('#address-'+idAddress+'-city--select option:contains('+inputCity+')').attr('selected', 'selected');
        
    });
 }
 getProvinceList();
